import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../base.component';
import { IngredientService } from "app/services/ingredient.service";
import { CompanyService } from "app/services/company.service";
import { UserService } from "app/services/user.service";
import { QuotationHistoryService } from "app/services/quotation-history.service";
import { NewsService } from "app/services/news.service";
import { DocumentService } from "app/services/document.service";
import { ImageService } from "app/services/image.service"
import { CategoryService } from "app/services/category.service";;

@Component({
	selector: 'app-home',
	templateUrl: './home.component.html',
	styleUrls: ['./home.component.css']
})
export class HomeComponent extends BaseComponent implements OnInit {
	ingLength = 0;
	comLength = 0;
	userLength = 0;
	quoLength = 0;
	newsLength = 0;
	docLength = 0;
	ImgLength = 0;
	catLength = 0;
	count = 0;
	quotationSent:any

	constructor(
		private ing: IngredientService,
		private com: CompanyService,
		private user: UserService,
		private quo: QuotationHistoryService,
		private news: NewsService,
		private doc: DocumentService,
		private Img: ImageService,
		private cat: CategoryService,
	) {
		super();
	}

	ngOnInit() {
		// var ingLengthOri = 0;
		this.ing.getIngredients().subscribe(ingredients => {
			this.animation('ingLength', ingredients.length, 0.001);
		})
		this.com.getCompanies().subscribe(companies => {
			this.animation('comLength', companies.length, 1);
		})
		this.user.getUsers().subscribe(users => {
			this.animation('userLength', users.length, 50);
		})
		this.news.getAllNews().subscribe(news => {
			this.animation('newsLength', news.length, 50);
		})
		this.doc.getDocuments().subscribe(doc => {
			this.animation('docLength', doc.length, 1);
		})
		this.Img.getImages().subscribe(img => {
			this.animation('ImgLength', img.length, 50);
		})
		this.cat.getCategories().subscribe(cat => {
			cat = cat.filter(item => {
				return item.goes_to != 'sub'
			})
			this.animation('catLength', cat.length, 100);
		})
		this.quo.getQuotations().subscribe(quo => {
			this.quotationSent = quo.filter(quot => {
				return quot.status == 'sent'
			})
			this.animation('quoLength', this.quotationSent.length, 1);
		})
	}

	animation(start, finish, interval) {
		var ani = setInterval(() => {
			if (this[start] < finish) {
				this[start]++;
			}
			else {
				clearInterval(ani);
			}
		}, interval);
	}

	ngAfterViewInit() {
		super.ngAfterViewInit();
		setTimeout(() => {
			window.dispatchEvent(new Event('data-loaded'));
		}, 500);
	}

}



// WEBPACK FOOTER //
// D:/www/kh_indesso_web/src/app/components/home/home.component.ts